<template>
 <Head>
    <title> Admin Announcement Report | {{$page.props.appName}}</title>
    <meta name="description" :content="'Announcement Report ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-full p-3 overflow-x-auto overflow-y-auto">
        <h1 class="text-2xl font-semibold ml-5">Announcement Report</h1>
         <p class="ml-5">See below the rendered report.</p>
          <table class="ml-5">
           <thead>
            <th class="p-2">Person</th>
            <th v-for="(announcement,key) in announcehead" :key="key" class="p-2">
                {{announcement.announcement_title}}
            </th>
           </thead>
            <tbody>
              <tr v-for="(person,k) in names" :key="k">
                <td class="text-center border border-black font-medium px-3 py-2 text-black bg-white">{{person.firstname}}  {{person.surname}}</td>
                <td v-for="(announcement,key) in announcehead" :key="key" class="text-center border border-black font-medium px-3 py-2 text-black bg-white">
                    {{handleSeen(announcements[announcement.announcement_title][person.id])}}
                </td>
              </tr>
            </tbody>
          </table>

    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head },
  props: {
    announcements: Object,
    announcehead : Object,
    names : Object,
    },
  data() {
    return {
      form: this.$inertia.form({
        announcements: 'ALL'
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/reports/announcementreport");

    },
    handleSeen(seenbool) {
      if(seenbool==0){
        return 'unseen';
      }else if(seenbool==1){
        return 'seen';
      }else{
        return 'N/A';
      }
    }
   
  },
};
</script>
     